'use client'
import type { FC, ReactNode } from 'react'
import { Box, HStack, type StackProps } from '@chakra-ui/react'
import { GrandText } from 'ui'

interface ICheckoutSummaryItemProps extends StackProps {
  label: string
  value: ReactNode
}

export const CheckoutSummaryItem: FC<ICheckoutSummaryItemProps> = ({ label, value, ...props }) => {
  return (
    <HStack fontSize="sm" justify="space-between" w="full" {...props}>
      <GrandText flex={1} w="auto">
        {label}
      </GrandText>
      <Box flex={0.4} textAlign="right" w="auto">
        {value}
      </Box>
    </HStack>
  )
}
